// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(entityType, id) {
  return {
    entityType: entityType,
    id: id
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_newConversationContextV5_context_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["VisibleForSalePropertyAgent"]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"newConversationContextV5_context_agentV2":{"u":"response_newConversationContextV5_context_agentV2"},"newConversationContextV5_context":{"f":""},"newConversationContextV5":{"f":""}}};

let wrapResponseConverterMap = {
  response_newConversationContextV5_context_agentV2: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"newConversationContextV5_context_agentV2":{"u":"response_newConversationContextV5_context_agentV2"},"newConversationContextV5_context":{"f":""},"newConversationContextV5":{"f":""}}};

let responseConverterMap = {
  response_newConversationContextV5_context_agentV2: unwrap_response_newConversationContextV5_context_agentV2
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function conversationContextTypeV5_decode($$enum) {
  if ($$enum === "BROADCAST_MESSAGE" || $$enum === "RENTAL_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_NEED" || $$enum === "FOR_SALE_PROPERTY") {
    return $$enum;
  }
}

let conversationContextTypeV5_fromString = conversationContextTypeV5_decode;

function membershipStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let membershipStatusV5_fromString = membershipStatusV5_decode;

function messageBroadcasStatus_decode($$enum) {
  if ($$enum === "DELETED" || $$enum === "RESUMABLE_DRAFT" || $$enum === "DRAFT" || $$enum === "PUBLISHED" || $$enum === "EXPIRED") {
    return $$enum;
  }
}

let messageBroadcasStatus_fromString = messageBroadcasStatus_decode;

let Utils = {
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: conversationContextTypeV5_fromString,
  membershipStatusV5_decode: membershipStatusV5_decode,
  membershipStatusV5_fromString: membershipStatusV5_fromString,
  messageBroadcasStatus_decode: messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: messageBroadcasStatus_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "entityType",
    "variableName": "entityType"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "RequiredField",
      "field": (v5/*: any*/),
      "action": "NONE"
    }
  ],
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": "messageBroadcastStatus",
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remarks",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientContactsConnection",
  "kind": "LinkedField",
  "name": "contacts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientContactsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientContactV5",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v15 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v16 = {
  "alias": null,
  "args": [
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v17 = {
  "alias": "agentProfilePhoto",
  "args": null,
  "concreteType": "ProfilePhoto",
  "kind": "LinkedField",
  "name": "profilePhoto",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v4/*: any*/),
    (v17/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "maxPrice",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "minPrice",
      "plural": false,
      "selections": (v19/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Area",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      (v10/*: any*/)
    ],
    "storageKey": null
  }
],
v22 = [
  (v4/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minBeds",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = [
  {
    "kind": "Literal",
    "name": "includeOnlyActive",
    "value": true
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ExactPrice",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "halfBaths",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingArea",
  "storageKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingSpaces",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingDetails",
      "storageKey": null
    }
  ],
  "type": "CondoProperty",
  "abstractKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v4/*: any*/)
  ],
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onTanAt",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onMlsAt",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffersPriorToMls",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShowPriorToMls",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsOn",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "ChapterV5",
  "kind": "LinkedField",
  "name": "chapter",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v50 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v51 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "crop",
                  "value": false
                },
                {
                  "kind": "Literal",
                  "name": "embed",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "height",
                  "value": 324
                },
                {
                  "kind": "Literal",
                  "name": "width",
                  "value": 324
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(crop:false,embed:true,height:324,width:324)"
            },
            (v10/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "images(first:1)"
},
v52 = [
  (v9/*: any*/),
  (v4/*: any*/),
  (v10/*: any*/)
],
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "Price",
  "kind": "LinkedField",
  "name": "maxPrice",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Price",
  "kind": "LinkedField",
  "name": "minPrice",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    (v53/*: any*/),
    (v54/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v32/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v30/*: any*/),
        (v33/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibilityRule",
          "storageKey": null
        }
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "mlsPlan",
  "plural": false,
  "selections": [
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isMlsPlan"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "willShow",
          "storageKey": null
        }
      ],
      "type": "NoMlsPlan",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsSince",
  "storageKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isPropertyPrice"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v54/*: any*/),
            (v53/*: any*/)
          ],
          "type": "PriceRange",
          "abstractKey": null
        },
        (v28/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v60 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentV2Id",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agent",
              "kind": "LinkedField",
              "name": "agent",
              "plural": false,
              "selections": (v50/*: any*/),
              "storageKey": null
            }
          ],
          "type": "VisibleForSalePropertyAgent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentId",
      "args": null,
      "concreteType": "Agent",
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": (v50/*: any*/),
      "storageKey": null
    },
    (v59/*: any*/)
  ],
  "type": "RentalPropertyV5",
  "abstractKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableFrom",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "LeaseLengthV5",
  "kind": "LinkedField",
  "name": "leaseLength",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationPageNewConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "newConversationContextV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationPageSelectedConversationContext_conversation"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationPageSelectedConversationMatches_conversation"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConversationPageNotAnonymousWarning_conversationContext"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationPageNewConversationDisplayer_conversationContext"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationsPageRelayCommon_conversationContext"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "BuyerNeedV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentV2",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v7/*: any*/),
                            "type": "VisibleForSalePropertyAgent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ForSalePropertyV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v6/*: any*/)
                    ],
                    "type": "MessageBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "RentalNeedV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "RentalPropertyV5",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AvailableConversationContext",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ConversationPageNewConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "newConversationContextV5",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isContextForConversation"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Agent",
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/),
                  (v4/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "RemovedConversationContext",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isConversationContextV5"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Buyer",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/)
                            ],
                            "type": "ClientV5",
                            "abstractKey": "__isClientV5"
                          }
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedAreaConnection",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedAreaEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v21/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BuyerNeedPropertyType",
                        "kind": "LinkedField",
                        "name": "propertyTypes",
                        "plural": true,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": "buyerNeedMatchingType",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "matchingType",
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "BuyerNeedCurrentUserMatchesConnection",
                        "kind": "LinkedField",
                        "name": "currentUsersMatches",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedCurrentUserMatchesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MatchForForSalePropertyV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ForSalePropertyV5",
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "propertyLocation",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v32/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v30/*: any*/),
                                              (v33/*: any*/)
                                            ],
                                            "type": "PropertyLocationWithVisibleAddress",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Seller",
                                        "kind": "LinkedField",
                                        "name": "client",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          (v4/*: any*/),
                                          (v13/*: any*/),
                                          (v10/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v10/*: any*/),
                                      {
                                        "alias": "forSalePropertyMatchingType",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "matchingType",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                      }
                    ],
                    "type": "BuyerNeedV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v37/*: any*/),
                              (v4/*: any*/)
                            ],
                            "type": "LotProperty",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numberOfUnits",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "type": "MultiUnitProperty",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commission",
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PropertyShowingConnection",
                        "kind": "LinkedField",
                        "name": "showings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PropertyShowingEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShowingV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startDate",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "mlsPlan",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "ListOnMlsAsActive",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v46/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/)
                            ],
                            "type": "ListOnMlsAsComingSoon",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v24/*: any*/),
                      (v49/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "agentV2",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/)
                            ],
                            "type": "VisibleForSalePropertyAgent",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "forSaleMatchingType",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "matchingType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": (v50/*: any*/),
                        "storageKey": null
                      },
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "matchingType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "ForSalePropertyCurrentUserMatchesConnection",
                        "kind": "LinkedField",
                        "name": "currentUsersMatches",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ForSalePropertyCurrentUserMatchesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MatchForBuyerNeedV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuyerNeedV5",
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Buyer",
                                        "kind": "LinkedField",
                                        "name": "client",
                                        "plural": false,
                                        "selections": (v52/*: any*/),
                                        "storageKey": null
                                      },
                                      (v55/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v58/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/)
                        ],
                        "type": "PropertyV5",
                        "abstractKey": "__isPropertyV5"
                      }
                    ],
                    "type": "ForSalePropertyV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "brokerage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProfilePhoto",
                            "kind": "LinkedField",
                            "name": "profilePhoto",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "alias": "urlWithRing",
                                "args": [
                                  (v14/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "ring",
                                    "value": true
                                  },
                                  (v15/*: any*/)
                                ],
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v17/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryV5",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subject",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "type": "MessageBroadcast",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Renter",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": (v50/*: any*/),
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedAreaConnection",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalNeedAreaEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v21/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RentalNeedPropertyType",
                        "kind": "LinkedField",
                        "name": "propertyTypes",
                        "plural": true,
                        "selections": (v22/*: any*/),
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "RentalNeedCurrentUserMatchesConnection",
                        "kind": "LinkedField",
                        "name": "currentUsersMatches",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalNeedCurrentUserMatchesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MatchForRentalPropertyV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalPropertyV5",
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "propertyLocation",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v32/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v31/*: any*/),
                                            "type": "PropertyLocationWithVisibleAddress",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Landlord",
                                        "kind": "LinkedField",
                                        "name": "client",
                                        "plural": false,
                                        "selections": (v52/*: any*/),
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                      }
                    ],
                    "type": "RentalNeedV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v39/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "mlsPlan",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v43/*: any*/)
                            ],
                            "type": "ListOnMlsAsActive",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v46/*: any*/)
                            ],
                            "type": "ListOnMlsAsComingSoon",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v49/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Landlord",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": (v50/*: any*/),
                        "storageKey": null
                      },
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": (v25/*: any*/),
                        "concreteType": "RentalPropertyCurrentUserMatchesConnection",
                        "kind": "LinkedField",
                        "name": "currentUsersMatches",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalPropertyCurrentUserMatchesEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MatchForRentalNeedV5",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedV5",
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Renter",
                                        "kind": "LinkedField",
                                        "name": "client",
                                        "plural": false,
                                        "selections": (v52/*: any*/),
                                        "storageKey": null
                                      },
                                      (v55/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v57/*: any*/),
                          (v58/*: any*/),
                          (v56/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/)
                        ],
                        "type": "PropertyV5",
                        "abstractKey": "__isPropertyV5"
                      }
                    ],
                    "type": "RentalPropertyV5",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AvailableConversationContext",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71b5d9a0a9e7f85a0a7f97f956c6a118",
    "id": null,
    "metadata": {},
    "name": "ConversationPageNewConversationQuery",
    "operationKind": "query",
    "text": "query ConversationPageNewConversationQuery(\n  $id: ID!\n  $entityType: ConversationContextTypeV5!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  newConversationContextV5(entityType: $entityType, id: $id) {\n    __typename\n    ...ConversationPageSelectedConversationContext_conversation\n    ...ConversationPageSelectedConversationMatches_conversation\n    ...ConversationPageNotAnonymousWarning_conversationContext\n    ... on AvailableConversationContext {\n      context {\n        __typename\n        ...ConversationPageNewConversationDisplayer_conversationContext\n        ...ConversationsPageRelayCommon_conversationContext\n        ... on BuyerNeedV5 {\n          agent {\n            displayName\n            membershipStatus\n            nodeId\n          }\n        }\n        ... on ForSalePropertyV5 {\n          agentV2 {\n            __typename\n            ... on VisibleForSalePropertyAgent {\n              agent {\n                displayName\n                membershipStatus\n                nodeId\n              }\n            }\n          }\n        }\n        ... on MessageBroadcast {\n          messageBroadcastStatus: status\n          agent {\n            displayName\n            membershipStatus\n            nodeId\n          }\n        }\n        ... on RentalNeedV5 {\n          agent {\n            displayName\n            membershipStatus\n            nodeId\n          }\n        }\n        ... on RentalPropertyV5 {\n          agent {\n            displayName\n            membershipStatus\n            nodeId\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment AgentPropertyMlsStatus_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on AlreadyOnMls {\n    __typename\n  }\n  ... on ListOnMlsAsActive {\n    onMlsAt\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n  }\n  ... on NoMlsPlan {\n    willShow\n  }\n}\n\nfragment AgentPropertyMlsStatus_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ...AgentPropertyMlsStatus_mlsPlan\n  }\n  activeOnMlsSince\n}\n\nfragment BuyerNeedStatus_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      __typename\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment CondoPropertyAttributes_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ConversationConversationsSectionStartFirstConversation_context on ConversationContextV5 {\n  __isConversationContextV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    id\n    agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          displayName\n          nodeId\n        }\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    id\n    agent {\n      displayName\n      nodeId\n    }\n  }\n  ... on MessageBroadcast {\n    id\n    agent {\n      displayName\n      nodeId\n    }\n  }\n  ... on BuyerNeedV5 {\n    id\n    agent {\n      displayName\n      nodeId\n    }\n  }\n  ... on RentalNeedV5 {\n    id\n    agent {\n      displayName\n      nodeId\n    }\n  }\n}\n\nfragment ConversationPageNewConversationByType_conversationContext on ConversationContextV5 {\n  __isConversationContextV5: __typename\n  __typename\n  ... on BuyerNeedV5 {\n    agent {\n      displayName\n      id\n      ...AgentProfilePhoto_agent\n      nodeId\n    }\n  }\n  ... on ForSalePropertyV5 {\n    agentV2 {\n      __typename\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          displayName\n          id\n          ...AgentProfilePhoto_agent\n          nodeId\n        }\n      }\n    }\n  }\n  ... on MessageBroadcast {\n    agent {\n      displayName\n      id\n      ...AgentProfilePhoto_agent\n      nodeId\n    }\n  }\n  ... on RentalNeedV5 {\n    agent {\n      displayName\n      id\n      ...AgentProfilePhoto_agent\n      nodeId\n    }\n  }\n  ... on RentalPropertyV5 {\n    agent {\n      displayName\n      id\n      ...AgentProfilePhoto_agent\n      nodeId\n    }\n  }\n}\n\nfragment ConversationPageNewConversationDisplayer_conversationContext on ConversationContextV5 {\n  __isConversationContextV5: __typename\n  __typename\n  ...ConversationPageNewConversationByType_conversationContext\n  ...ConversationConversationsSectionStartFirstConversation_context\n}\n\nfragment ConversationPageNotAnonymousWarning_conversationContext on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on BuyerNeedV5 {\n        agent {\n          displayName\n          nodeId\n        }\n        currentUsersMatches(includeOnlyActive: true) {\n          edges {\n            node {\n              source {\n                client {\n                  displayName\n                  nodeId\n                }\n                forSalePropertyMatchingType: matchingType\n                nodeId\n              }\n              nodeId\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationContextRemovedContextCard_agent on Agent {\n  id\n  membershipStatus\n  displayName\n}\n\nfragment ConversationPageSelectedConversationContext_broadcast on MessageBroadcast {\n  id\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n  category {\n    shortName\n  }\n  subject\n  body\n}\n\nfragment ConversationPageSelectedConversationContext_buyerNeed on BuyerNeedV5 {\n  id\n  headline\n  remarks\n  client {\n    id\n    ...ConversationsPageRelayCommonGetClientNames_client\n    nodeId\n  }\n  agent {\n    id\n    nodeId\n  }\n  priceRange {\n    maxPrice {\n      formatted(format: SHORT)\n    }\n    minPrice {\n      formatted(format: SHORT)\n    }\n  }\n  areas {\n    edges {\n      node {\n        name\n        label\n        nodeId\n      }\n    }\n  }\n  propertyTypes {\n    displayName\n  }\n  minBeds\n  buyerNeedMatchingType: matchingType\n  ...BuyerNeedStatus_buyerNeedV5\n}\n\nfragment ConversationPageSelectedConversationContext_conversation on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on RemovedConversationContext {\n    entityType\n    agent {\n      ...ConversationPageSelectedConversationContextRemovedContextCard_agent\n      nodeId\n    }\n  }\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on BuyerNeedV5 {\n        ...ConversationPageSelectedConversationContext_buyerNeed\n      }\n      ... on ForSalePropertyV5 {\n        ...ConversationPageSelectedConversationContext_forSaleProperty\n      }\n      ... on MessageBroadcast {\n        ...ConversationPageSelectedConversationContext_broadcast\n      }\n      ... on RentalNeedV5 {\n        ...ConversationPageSelectedConversationContext_rentalNeed\n      }\n      ... on RentalPropertyV5 {\n        ...ConversationPageSelectedConversationContext_rentalProperty\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationContext_forSaleProperty on ForSalePropertyV5 {\n  id\n  nodeId\n  ...PropertyLocationForCard_propertyV5\n  ...ForSalePropertyAttributes_property\n  ...PropertyMlsLabel_propertyV5\n  ...PropertyPageForSalePropertyListingDetails_property\n  ...ForSalePropertyStatus_forSalePropertyV5\n  description\n  ...PropertyPrice_property\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        id\n        nodeId\n      }\n    }\n  }\n  ...ForSalePropertyLabels_property\n  client {\n    id\n    nodeId\n  }\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 324, height: 324, crop: false, embed: true)\n        nodeId\n      }\n    }\n  }\n  matchingType\n}\n\nfragment ConversationPageSelectedConversationContext_rentalNeed on RentalNeedV5 {\n  id\n  headline\n  remarks\n  client {\n    id\n    nodeId\n  }\n  agent {\n    id\n    nodeId\n  }\n  priceRange {\n    maxPrice {\n      formatted(format: SHORT)\n    }\n    minPrice {\n      formatted(format: SHORT)\n    }\n  }\n  areas {\n    edges {\n      node {\n        name\n        label\n        nodeId\n      }\n    }\n  }\n  propertyTypes {\n    displayName\n  }\n  minBeds\n  ...RentalNeedLeaseAttributes_rentalNeedV5\n  ...RentalNeedStatus_rentalNeedV5\n}\n\nfragment ConversationPageSelectedConversationContext_rentalProperty on RentalPropertyV5 {\n  id\n  ...RentalPropertyStatus_rentalPropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...RentalPropertyAttributes_property\n  ...PropertyMlsLabel_propertyV5\n  ...PropertyPageRentalPropertyListingDetails_property\n  ...RentalPropertyLease_rentalProperty\n  description\n  ...PropertyPrice_property\n  agent {\n    id\n    nodeId\n  }\n  client {\n    id\n    nodeId\n  }\n  images(first: 1) {\n    edges {\n      node {\n        ...PropertyCardImage_image\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesBuyerMatches_match on MatchForBuyerNeedV5 {\n  id\n  source {\n    client {\n      id\n      displayName\n      nodeId\n    }\n    priceRange {\n      maxPrice {\n        formatted(format: FULL)\n      }\n      minPrice {\n        formatted(format: FULL)\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesRentalOwnerMatches_match on MatchForRentalPropertyV5 {\n  source {\n    price {\n      __typename\n      ... on ExactPrice {\n        price {\n          formatted(format: FULL)\n        }\n      }\n    }\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        locationDisplay\n      }\n    }\n    client {\n      id\n      displayName\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesRenterMatches_match on MatchForRentalNeedV5 {\n  id\n  source {\n    client {\n      id\n      displayName\n      nodeId\n    }\n    priceRange {\n      maxPrice {\n        formatted(format: FULL)\n      }\n      minPrice {\n        formatted(format: FULL)\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesSellerMatches_match on MatchForForSalePropertyV5 {\n  id\n  source {\n    price {\n      __typename\n      ... on ExactPrice {\n        price {\n          formatted(format: FULL)\n        }\n      }\n    }\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        locationDisplay\n        address\n      }\n    }\n    client {\n      id\n      displayName\n      contacts {\n        edges {\n          node {\n            displayName\n            nodeId\n          }\n        }\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatches_conversation on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on RemovedConversationContext {\n    agent {\n      id\n      nodeId\n    }\n  }\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on ForSalePropertyV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesBuyerMatches_match\n              nodeId\n            }\n          }\n        }\n        agentV2 {\n          __typename\n          ... on VisibleForSalePropertyAgent {\n            agent {\n              id\n              nodeId\n            }\n          }\n        }\n      }\n      ... on RentalPropertyV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesRenterMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on BuyerNeedV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesSellerMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on RentalNeedV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesRentalOwnerMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsPageRelayCommonGetClientNames_client on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  id\n  contacts {\n    edges {\n      node {\n        displayName\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsPageRelayCommon_conversationContext on ConversationContextV5 {\n  __isConversationContextV5: __typename\n  __typename\n  ... on BuyerNeedV5 {\n    id\n  }\n  ... on ForSalePropertyV5 {\n    id\n  }\n  ... on MessageBroadcast {\n    id\n  }\n  ... on RentalNeedV5 {\n    id\n  }\n  ... on RentalPropertyV5 {\n    id\n  }\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...LotPropertyAttributes_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...MultiUnitPropertyAttributes_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertyLabels_property on ForSalePropertyV5 {\n  id\n  forSaleMatchingType: matchingType\n  agentV2 {\n    __typename\n    ... on AnonymousForSalePropertyAgent {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertyStatus_forSalePropertyV5 on ForSalePropertyV5 {\n  ...AgentPropertyMlsStatus_property\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment LotPropertyAttributes_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment MultiUnitPropertyAttributes_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment PropertyCardImage_image on ImageAttachment {\n  url(width: 324, height: 324, crop: false, embed: true)\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPageForSalePropertyListingDetails_property on ForSalePropertyV5 {\n  commission\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      parkingSpaces\n      parkingDetails\n    }\n  }\n  onTanAt\n  updatedAt\n  showings {\n    edges {\n      node {\n        startDate\n        nodeId\n      }\n    }\n  }\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n      willAcceptOffersPriorToMls\n      willShowPriorToMls\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n      willAcceptOffersPriorToMls\n      willShowPriorToMls\n    }\n  }\n  website\n  chapter {\n    timezone\n    nodeId\n  }\n}\n\nfragment PropertyPageRentalPropertyListingDetails_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      parkingSpaces\n      parkingDetails\n    }\n  }\n  onTanAt\n  updatedAt\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n  }\n  website\n  chapter {\n    timezone\n    nodeId\n  }\n}\n\nfragment PropertyPrice_price_4wzfKn on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_4wzfKn\n  }\n}\n\nfragment PropertyPrice_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_4wzfKn\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_4wzfKn\n  }\n}\n\nfragment PropertyPrice_propertyPrice_4wzfKn on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: FULL)\n    }\n    maxPrice {\n      formatted(format: FULL)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment RentalNeedLeaseAttributes_rentalNeedV5 on RentalNeedV5 {\n  availableFrom\n  leaseLength {\n    displayName\n  }\n}\n\nfragment RentalNeedStatus_rentalNeedV5 on RentalNeedV5 {\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      __typename\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n    ... on RemovedRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment RentalPropertyAttributes_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n  }\n}\n\nfragment RentalPropertyLease_rentalProperty on RentalPropertyV5 {\n  availableFrom\n  leaseLength {\n    displayName\n  }\n}\n\nfragment RentalPropertyStatus_rentalPropertyV5 on RentalPropertyV5 {\n  ...AgentPropertyMlsStatus_property\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on RentedProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment SingleFamilyPropertyAttributes_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_newConversationContextV5_context_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_newConversationContextV5_context_agentV2 = unwrap_response_newConversationContextV5_context_agentV2;
exports.wrap_response_newConversationContextV5_context_agentV2 = wrap_response_newConversationContextV5_context_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
